var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showLoading ? _c("div", { staticClass: "jleague_loader" }) : _vm._e(),
    _vm._v(" "),
    _c(
      "form",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showLoading,
            expression: "!showLoading",
          },
        ],
        ref: "removeOneTouchPassForm",
        attrs: { method: "post" },
      },
      [
        _c("input", {
          attrs: { name: _vm.csrfName, type: "hidden" },
          domProps: { value: _vm.csrf },
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { name: "token", type: "hidden" },
          domProps: { value: _vm.token },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.jsonPatchForUserInfo,
              expression: "jsonPatchForUserInfo",
            },
          ],
          attrs: { name: "userinfo_patch", type: "hidden" },
          domProps: { value: _vm.jsonPatchForUserInfo },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.jsonPatchForUserInfo = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _vm.displayOneTouchList.length
          ? _vm._l(_vm.displayOneTouchList, function (pass) {
              return _c("div", { staticClass: "oneTouchContainer" }, [
                _c("table", [
                  _c("tr", [
                    _c("th", [_vm._v("ワンタッチパスID")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(pass.otp_id))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("クラブ")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(_vm._s(_vm._f("clubTeamName")(pass.club_cd))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("グレード")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(pass.member_classification_nm))]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("有効開始日")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(pass.member_effective_start_ymd)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("有効終了日")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormat")(pass.member_effective_end_ymd)
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "return",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.removeOneTouchPass(pass)
                        },
                      },
                    },
                    [_vm._v("解除")]
                  ),
                ]),
              ])
            })
          : _c("div", [_vm._m(0)]),
        _vm._v(" "),
        _c("div", { staticClass: "btnSpace duo single-on-sp" }, [
          _c(
            "button",
            {
              staticClass: "return",
              attrs: { type: "button" },
              on: { click: _vm.backToHome },
            },
            [_vm._v("メニューに戻る")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { name: "registration", type: "button" },
              on: { click: _vm.addOneTouchPass },
            },
            [_vm._v("ワンタッチパスIDを追加する")]
          ),
        ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "msg" }, [
      _c("em", { staticClass: "errNote" }, [
        _vm._v("ワンタッチパスが未登録です"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }